import Vue from 'vue'
import VueRouter from 'vue-router'
import { isMobileUA, isMobileView } from 'mdetect'
import MHome from './views/Home.vue'
import Home from './views/Home.vue'
import Zuopin from './views/Zuopin.vue'
import Pinglun from './views/Pinglun.vue'
import Jiaoliu from './views/Jiaoliu.vue'
import Suiyue from './views/Suiyue.vue'
import Message from './views/Message.vue'
import Huazhan from './views/Huazhan.vue'
import Show from './views/Show.vue'
Vue.use(VueRouter)

const mb = (isMobileUA() || isMobileView()) ? MHome : Home;

export const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '', redirect: 'index' },
    { path: '/index', name: 'index', component: mb },
    { path: '/zuopin', name: 'zuopin', component: Zuopin },
    { path: '/pinglun', name: 'pinglun', component: Pinglun },
    { path: '/pinglun/:id', name: 'show', component: Show, props: true },
    { path: '/jiaoliu', name: 'jiaoliu', component: Jiaoliu },
    { path: '/suiyue', name: 'suiyue', component: Suiyue },
    { path: '/message', name: 'message', component: Message },
    { path: '/huazhan', name: 'huazhan', component: Huazhan }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
